import React, { useState, useCallback, useRef } from 'react'
import { FaFilter } from 'react-icons/fa'
import { StandardCheckbox } from 'components'
import { DropdownButton, DropdownMenu } from './style'
import { ListGroup } from 'react-bootstrap'
import { useGlobalClick } from 'hooks/useWindowEvent'

const MultiSelectCheckboxes = (
  {
    options,
    onChange,
    selectedOptions = [],
    optionValue = 'value',
    optionLabel = 'label',
    showAllLabel = 'Show All',
    ...rest
  },
) => {
  const [isMenuOpen, _setIsMenuOpen] = useState()
  const widgetRef = useRef()
  const isMenuOpenRef = useRef() // Needed to be accessible through global listeners
  const setIsMenuOpen = useCallback(value => {
    isMenuOpenRef.current = value
    _setIsMenuOpen(value)
  }, [isMenuOpenRef, _setIsMenuOpen])

  useGlobalClick((event) => {
    if (isMenuOpenRef.current && !widgetRef.current?.contains(event.target)) {
      setIsMenuOpen(false)
    }
  })

  const toggleMenu = useCallback(() => setIsMenuOpen(!isMenuOpen), [setIsMenuOpen, isMenuOpen])
  const handleChange = useCallback((value, { target: { checked } }) => {
    if (checked) {
      if (value === '*') { // Select All was chosen
        return onChange([])
      }
      return onChange([...selectedOptions, value])
    } else {
      if (value !== '*') { // Select All is unable to uncheck manually
        return onChange(selectedOptions.filter(opt => opt !== value))
      }
    }
  }, [onChange, selectedOptions])

  return (
    <span ref={widgetRef} {...rest}>
      <DropdownButton
        variant="secondary"
        onClick={toggleMenu}
        $applied={!!selectedOptions?.length}
      >
        <FaFilter />
      </DropdownButton>
      {
        isMenuOpen &&
        <DropdownMenu>
          <ListGroup>
            {
              [{ [optionLabel]: showAllLabel, [optionValue]: '*' }, ...options].map(opt =>
                <ListGroup.Item key={opt[optionValue]} className="py-1 px-2 border-0">
                  <StandardCheckbox
                    onChange={handleChange.bind(null, opt[optionValue])}
                    checked={
                      opt[optionValue] !== '*' ?
                        !!selectedOptions.find(chosen => chosen === opt[optionValue])
                        : !selectedOptions.length
                    }
                    label={opt[optionLabel]}
                  />
                </ListGroup.Item>
              )
            }
          </ListGroup>
        </DropdownMenu>
      }
    </span>
  )
}

export default React.memo(MultiSelectCheckboxes)
